module.exports = __webpack_public_path__ + "img/userCertiIcon.82747990.svg";